export default {"src":"https://images-cdn.curipod.com/d-eb002c81/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};